__turbopack_context__.v({
  "root": "tweet-info-created-at-module__12EM3G__root",
});
